import { useCallback } from 'react'
import { useRouter } from 'next/router'

import { IOptionAliases } from 'constants/types/search.types'
import { Pathname } from 'constants/data'

const useWebinarSelectedOption = (OptionAliases: IOptionAliases) => {
  const router = useRouter()

  const routeSegments = router.pathname.split('/')
  const currOption = routeSegments[2] // /library/video/target ...
  const foundOption = OptionAliases.find(
    (option) => option.option === currOption || option.alias === currOption
  )
  const selectedOption = foundOption ? foundOption.option : OptionAliases[0].option

  const setSelectedOption = useCallback((option: string) => {
    const foundOption = OptionAliases.find((o) => o.option === option || o.alias === option)

    router.replace(`/${Pathname.WEBINAR}/${foundOption?.alias || ''}`, undefined, {
      shallow: true,
    })
  }, [])

  return { selectedOption, setSelectedOption }
}

export default useWebinarSelectedOption
